<template>
  <div class="select-wrap">
    <span 
      v-if="!ui.options.length"
      style="position: relative;
      font-size: 12px;
      display: inline-block;
      ">无数据</span>
    <Select
      v-else
      :props="ui.component.props"
      :value="value"
      @change="onChange"
      />
    <!-- 品牌下拉框需要有个刷新品牌的按钮 -->
    <el-link v-if="isBrand" :disabled="brandLoading" v-loading="brandLoading" class="no-border fresh-btn" @click="refreshBrandList">刷新品牌</el-link>
  </div>
  
</template>

<script>
import Select from './index'
import { syncShopBrand, getSyncShopBrandStatus, getTmBrandList } from '@/servers/prod/center/tm'
export default {
  components: {Select},
  props: ['value', 'shopId', 'ui'],
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      brandLoading: false
    }
  },
  computed: {
    isBrand() {
      return ['prop_20000'].includes(this.ui.name)
    }
  },
  methods: {
    onChange(v) {
      this.$emit('change', v)
    },
    refreshBrandList() {
      this.brandLoading = true
      syncShopBrand({shopId: this.shopId})
      .then(res => {
        // 查询刷新的结果
        this.getRefreshResult(this.shopId)
      }).catch(err => {
        this.brandLoading = false
      })
    },
    getRefreshResult(shopId) {
      getSyncShopBrandStatus({shopId}).then(res => {
        if (res.finished) {
          this.updateBrandList(shopId)
        } else {
          setTimeout(() => {
            this.getRefreshResult(shopId)
          }, 1000)
        }
      }).catch(err => {
        this.brandLoading = false
      })
    },
    updateBrandList(shopId) {
      getTmBrandList({
        shopId
      }).then(res => {
        const _options = this.ui._options
        this.ui.options = res.filter(brand => _options.find(op => op.value === `${brand.vid}`)).map(brand => ({displayName: brand.name, value: `${brand.vid}`}))
        this.brandLoading = false
      }).catch(err => {
        this.brandLoading = false
        console.log(err, '------updateBrandList')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-wrap {
  width: 180px;
  display: flex;
  align-items: center;
}
.fresh-btn {
  margin-left: 15px;
  flex-shrink: 0;
}
</style>